import { render } from "./LogoutButton.vue?vue&type=template&id=20313fe4"
import script from "./LogoutButton.vue?vue&type=script&lang=ts"
export * from "./LogoutButton.vue?vue&type=script&lang=ts"
script.render = render

export default script